module.exports = __webpack_public_path__ + "static/media/TP4.e23843c1.jpg";